export const SET_BREAD_CRUMBS = "SET_BREAD_CRUMBS";

export const setBreadcrumbs = (payload) => ({
    type: SET_BREAD_CRUMBS,
    payload,
});
